// Import react-native-get-random-values polyfill FIRST
import "react-native-get-random-values";

// Import polyfills only in Node.js environment where ReadableStream might be missing
if (typeof window === "undefined" && typeof ReadableStream === "undefined") {
  require("./polyfills");
}

import "expo-asset";

import React, { useEffect, useState } from "react";
import { AppRegistry, Platform, Image } from "react-native";
import { registerRootComponent } from "expo";
// Network failures as TypeError again so Amplify retries them; after "expo"
// (it installs the global fetch), before App (it configures Amplify).
import "./utils/installFetchNetworkErrors";
// import "react-native-url-polyfill/auto";
import { isLanguageReady, whenLanguageReady } from "./localization";

if (Platform.OS === "web") {
  Image.resolveAssetSource = (source) => {
    uri: source;
  };
}

// The app loads once its language is known (a quick AsyncStorage read on
// phones; at once on the web), so every screen, including text set at the top
// of a module, comes up in that language.
function Root() {
  const [ready, setReady] = useState(isLanguageReady);
  useEffect(() => {
    if (!ready) whenLanguageReady().then(() => setReady(true));
  }, [ready]);
  if (!ready) return null;
  const App = require("./App").default;
  return <App />;
}

// AppRegistry.registerComponent("main", () => App);
registerRootComponent(Root);
